/**
 * WHAT A PDU IS CALLED ON SCREEN (Hamzah, 2026-10-21): "PDU unit 1" for a unit of the site's one PDU,
 * "PDU 2 unit 1" where the site has several, "PDU" or "PDU 2" for one without units; never the vendor's
 * "Huawei PDU8000 Main+Module Metering, unit 1" across three lines of a tile, which stays its tooltip
 * and aria-label. The number is the order by id, as `dcSystemNames` numbers a system without its own.
 */
export function pduLabel(pduIds: readonly number[], deviceId: number, unit: number | null): string {
  const ids = [...new Set(pduIds)].sort((a, b) => a - b);
  const n = ids.length > 1 ? ` ${ids.indexOf(deviceId) + 1}` : '';
  return `PDU${n}${unit === null ? '' : ` unit ${unit}`}`;
}
